<template>
	<div>
		<div class="wrapper1200" style="display: flex;margin-top: 20px;">
			<div class="classification">
				<div class="singleType" :class="typeIndex==0?'active':''" @click="switchType(0)">测评答题</div>
				<div class="singleType" :class="typeIndex==1?'active':''" @click="switchType(1)">测评记录</div>
			</div>
			<div class="diagnosis" v-if="typeIndex==0">
				<div class="crumbs">饮食指导 > 测评答题</div>
				<div class="stagQuestions" v-if="startOrNot==0">
					<img src="../assets/image/dietaryGuidance.png" alt="" />
					<div class="northwestIsBeingRectified">
						<div class="evaluation" @click="answerList(0)">开始测评</div>
						<div class="evaation" @click="answerList(1)">四虚体质辩证</div>
					</div>
					<div class="evtionTips">
						中医智慧讲“药食同源”，食物同样具备“四气五味”的属性。以“辛味”为例：适量可发散寒气、促进气血流通；过量则可能耗气伤津，导致口干与乏力。精准饮食的关键，在于了解食物的本质并合理运用。饮食指导软件内置专业的食物属性数据库，帮您洞察每一种食材的“性格”，智能生成饮食报告与调理建议。
					</div>
					<!-- <div class="evtionTips">本次测试题共计{{problem.total}}道题，预计需要{{problem.timer}}分钟的时间</div> -->
				</div>
				<div class="evation" v-if="startOrNot==1">
					<div class="assessmentProgress">
						<div class="speedOfProgress">测评进度</div>
						<div class="numberOfAnswers"><span>{{whatQuestionIsIt+1}}</span>/{{total}}</div>
					</div>
					<div class="progressBar">
						<el-progress :percentage="((whatQuestionIsIt+1)/total)*100" color="#967255" :show-text='false'
							define-back-color='#D7C5AC' :stroke-width="10"></el-progress>
					</div>
					<div class="topicType">{{topicContent.secondType==0?'【单选题】':'【多选题】'}}</div>
					<div class="titles">{{whatQuestionIsIt+1}}.{{topicContent.topic}}</div>
					<div class="topicSelection">
						<div class='singleOption' v-for="(item,index) in list" :key="index" @click="select(index,item)"
							:class="{'span-active':selectedArr.indexOf(index) !==-1}">{{item.answer}}</div>
					</div>
					<div class="selectType">
						<div class="previousQuestion" @click="previousMention">上一题</div>
						<div class="nextQuestion" @click="nextQuestion">{{total==(whatQuestionIsIt+1)?'提交':'下一题'}}</div>
					</div>
				</div>
				<div class="ratingBackground" v-if="startOrNot==-1">
					<div class="backgroundImage">
						<img src="../assets/image/evaluationBackground.png" alt="" />
					</div>
					<div class="ratingPerson">
						<img :src="information.avatar==''?'../assets/logo.png':information.avatar" alt=""
							class="headPortrait" />
						<div class="nickname">
							<div class="rPerson">
								<div>{{information.realName}}</div>
								<img src="../assets/icon/male.png" alt="" />
							</div>
							<div class="age">年龄：{{information.age}}岁</div>
						</div>
					</div>
					<div class="answeringScore">
						<div class="fraction">本次答题<span>{{evaluationResults.grade}}</span>分</div>
						<div class="testTime">测试时间：{{evaluationResults.createTime}}</div>
					</div>
				</div>
				<div class="linkDeduction" v-if="startOrNot==-1">
					<img src="../assets/icon/link.png" alt="" class="leftLink" />
					<img src="../assets/icon/link.png" alt="" class="rightLink" />
				</div>
				<div class="resultContent" v-if="startOrNot==-1">
					<div class="titlese">诊断结果</div>
					<div class="diagnosticContent">
						<div v-if="currentDiagnoseData">
							<div v-if="currentDiagnoseData.ress || currentDiagnoseData.name"
								style="font-weight: bold; margin-bottom: 10px;">
								{{ currentDiagnoseData.ress || currentDiagnoseData.name }}
							</div>
							<div v-for="(label, key) in edibleMap" :key="key">
								<div v-if="currentDiagnoseData[key] && currentDiagnoseData[key].length > 0">
									<div style="color: #DF632B; font-weight: bold; margin-top: 10px;">{{label}}：</div>
									<div v-for="(item, index) in currentDiagnoseData[key]" :key="index"
										style="margin-top: 5px;">
										<div @click="toggleItem(item)"
											style="cursor: pointer; display: flex; align-items: center;">
											<span v-if="item.name" style="font-weight: bold;">{{item.name}}</span>
											<i :class="item.isOpen ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
												style="margin-left: 5px; color: #999;"></i>
										</div>
										<div v-show="item.isOpen" style="padding-left: 20px; margin-top: 5px;">
											<span v-if="item.foods">{{formatFoods(item.foods)}}</span>
										</div>
									</div>
								</div>
							</div>
							<div style="font-weight: bold; margin-bottom: 10px;">
								每个食品都具有多重属性，为了便于您有针对性的增加或减少某属性食品，则优先排序食品常见属性。如西瓜是寒和甘属性，考虑到阳虚体质过多食用西瓜会更加体寒，因此西瓜罗列到寒属性，其它食品同样。特此提醒：若需要纠正饮食偏嗜，主要以四气五味属性为主，归经属性可忽略。
							</div>
						</div>
						<div v-else>{{formatDiagnose(evaluationResults.diagnose)}}</div>
					</div>
					<div class="titlese">诊断依据</div>
					<div class="diagnosticContent">{{evaluationResults.according}}</div>
					<div class="titlese">治疗方案</div>
					<div class="diagnosticContent">{{evaluationResults.scheme}}</div>
					<div class="downloadFile" @click="downloadPDF(evaluationResults.fileUrl)">下载PDF文件</div>
				</div>
			</div>
			<div class="diagnosis" v-if="typeIndex==1" style="flex: 1;">
				<div class="crumbs" @click="resultId=''">饮食指导 > 测评记录</div>
				<div v-if="resultId==''">
					<div class="score" v-for="(item,index) in listOfCases" :key="index" style="margin-bottom: 10px;"
						@click="diagnosticDetails(item)">
						<div class="scoreser">
							<img src="../assets/icon/score.png" alt="" />
							<div>测评得分<span>{{item.grade}}</span>分</div>
						</div>
						<div class="scoringTime">{{item.createTime}}</div>
					</div>
					<div class="defaults" v-if="listOfCases==''">
						<el-empty description="暂无数据"></el-empty>
					</div>
				</div>
				<div v-if="resultId!=''">

					<div class="ratingBackground">
						<div class="backgroundImage">
							<img src="../assets/image/evaluationBackground.png" alt="" />
						</div>
						<div class="ratingPerson">
							<img :src="information.avatar==''?'../assets/logo.png':information.avatar" alt=""
								class="headPortrait" />
							<div class="nickname">
								<div class="rPerson">
									<div>{{information.realName}}</div>
									<img src="../assets/icon/male.png" alt="" />
								</div>
								<div class="age">年龄：{{information.age}}岁</div>
							</div>
						</div>
						<div class="answeringScore">
							<div class="fraction">本次答题<span>{{detailsOfCases.grade}}</span>分</div>
							<div class="testTime">测试时间：{{detailsOfCases.createTime}}</div>
						</div>
					</div>
					<div class="linkDeduction">
						<img src="../assets/icon/link.png" alt="" class="leftLink" />
						<img src="../assets/icon/link.png" alt="" class="rightLink" />
					</div>
					<div class="resultContent">
						<!-- <div class="titlese">诊断结果</div> -->
						<div class="titlese">诊断结果</div>
						<div class="diagnosticContent">
							<div v-if="recordDiagnoseData">
								<div v-if="recordDiagnoseData.ress || recordDiagnoseData.name"
									style="font-weight: bold; margin-bottom: 10px;">
									{{ recordDiagnoseData.ress || recordDiagnoseData.name }}
								</div>
								<div v-for="(label, key) in edibleMap" :key="key">
									<div v-if="recordDiagnoseData[key] && recordDiagnoseData[key].length > 0">
										<div style="color: #DF632B; font-weight: bold; margin-top: 10px;">{{label}}：
										</div>
										<div v-for="(item, index) in recordDiagnoseData[key]" :key="index"
											style="margin-top: 5px;">
											<div @click="toggleItem(item)"
												style="cursor: pointer; display: flex; align-items: center;">
												<span v-if="item.name" style="font-weight: bold;">{{item.name}}</span>
												<i :class="item.isOpen ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
													style="margin-left: 5px; color: #999;"></i>
											</div>
											<div v-show="item.isOpen" style="padding-left: 20px; margin-top: 5px;">
												<span v-if="item.foods">{{formatFoods(item.foods)}}</span>
											</div>
										</div>
									</div>
								</div>
								<div style="font-weight: bold; margin-bottom: 10px;">
									每个食品都具有多重属性，为了便于您有针对性的增加或减少某属性食品，则优先排序食品常见属性。如西瓜是寒和甘属性，考虑到阳虚体质过多食用西瓜会更加体寒，因此西瓜罗列到寒属性，其它食品同样。特此提醒：若需要纠正饮食偏嗜，主要以四气五味属性为主，归经属性可忽略。
								</div>
							</div>
							<div v-else>{{formatDiagnose(detailsOfCases.diagnose)}}</div>
						</div>
						<div class="titlese">诊断依据</div>
						<div class="diagnosticContent">{{detailsOfCases.according}}</div>
						<div class="titlese">治疗方案</div>
						<div class="diagnosticContent">{{detailsOfCases.scheme}}</div>
						<div class="downloadFile" @click="downloadPDF(detailsOfCases.fileUrl)">下载PDF文件</div>
					</div>
				</div>
			</div>


		</div>
		<el-dialog title="" :visible.sync="dialogTableVisible" :show-close='false'>
			<div class="endEvaluation">
				<div class="title">结束测评</div>
				<div class="contentDissemination">您未完成测评，退出后将不保存做题结果，确定退出吗？</div>
				<div class="operationButton">
					<div class="determine" @click="confirmToClose">确定</div>
					<div class="cancel" @click="dialogTableVisible=false">取消</div>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="" :visible.sync="suspectedDiagnosis" :show-close='false' class="organized">
			<div class="isItClosed">
				<img src="../assets/image/before8Oclock.png" alt="" />
				<div class="overallContent" style="top: 180px;">
					<div class="contentser">根据本次答题判断出您有明显的{{healthContent}}，需要饮食调理请点击下一步开始《为您提供专属饮食调养方案》</div>
					<div class="buttonOperation" @click="suspected">下一步</div>
				</div>
			</div>
			<div class="closeButton" @click="suspectedDiagnosis=false">
				<img src="../assets/icon/empty.png" alt="" />
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		answer,
		getTheProblem,
		submitResults,
		endTheQuiz,
		resultList,
		diagnosticResultDetails,
		userInformation,
		problemInformation,
		newProblem
	} from "@/api/api.js"
	export default {
		data() {
			return {
				typeIndex: 0,
				list: [],
				startOrNot: 0,
				total: 0,
				topicContent: '',
				whatQuestionIsIt: 0,
				selectedArr: [],
				answerIds: [],
				evaluationResults: '',
				listOfCases: '',
				resultId: '',
				detailsOfCases: '',
				dialogTableVisible: false,
				information: '',
				problem: '',
				local: '',
				classid: 0,
				healthContent: '',
				edibleMap: {
					'addEdible': '增加（常食食物无需理会，继续保持。需注意的是从不，偶尔和较多食物需在无过敏等其他情况下过渡到常食)',
					'normalEdible': '合宜（无需理会，继续保持）',
					'reduceEdible': '减少 （偶尔食物无需理会，继续保持，需注意的是从常食或较多食物过渡到偶尔） '
				},
				suspectedDiagnosis: false,
				currentDiagnoseData: null,
				recordDiagnoseData: null
			}
		},
		created() {
			this.startOrNot = 0
			// this.subject()
			this.resultCategory()
			this.personalInformation()
			this.emInformation()
			this.local = JSON.parse(localStorage.getItem('local'))
		},
		methods: {
			formatDiagnose(val) {
				if (!val) return ''
				return val.replace(/第/g, '\n第').replace(/。/g, '。\n')
			},
			formatFoods(foods) {
				if (!foods) return '';
				if (typeof foods === 'string') return foods;
				if (!Array.isArray(foods)) return '';
				return foods.map(item => {
					if (typeof item === 'object' && item !== null && item.name) {
						return item.answer ? `${item.name}(${item.answer})` : item.name;
					}
					return item;
				}).join('、');
			},
			processDiagnoseData(str) {
				try {
					if (typeof str != 'string') return null;
					var obj = JSON.parse(str);
					if (typeof obj == 'object' && obj) {
						if (obj.addEdible || obj.normalEdible || obj.reduceEdible || obj.name || obj.ress) {
							// Initialize isOpen property for toggle functionality
							['addEdible', 'normalEdible', 'reduceEdible'].forEach(key => {
								if (obj[key] && Array.isArray(obj[key])) {
									obj[key].forEach(item => {
										this.$set(item, 'isOpen', false);
									});
								}
							});
							return obj;
						}
					}
					return null;
				} catch (e) {
					return null;
				}
			},
			toggleItem(item) {
				if (item) {
					item.isOpen = !item.isOpen;
				}
			},
			parseDietaryData(str) {
				try {
					if (typeof str != 'string') return false;
					var obj = JSON.parse(str);
					if (typeof obj == 'object' && obj) {
						if (obj.addEdible || obj.normalEdible || obj.reduceEdible || obj.name) {
							return obj;
						}
					}
					return false;
				} catch (e) {
					return false;
				}
			},
			suspected() {
				this.suspectedDiagnosis = false
				this.answerList(0)
			},
			downloadPDF(fileName) {
				// const folderPath = '/path/to/folder/'; // 文件所在的文件夹路径
				const fileUrl = fileName; // 拼接文件夹路径和文件名
				const link = document.createElement('a');
				link.href = fileUrl;
				link.setAttribute('download', fileName);
				link.click();

			},
			//问题信息
			emInformation() {
				problemInformation({
					type: 1
				}).then(res => {
					this.problem = res.data
				})
			},
			// 用户信息
			personalInformation() {
				userInformation().then(res => {
					this.information = res.data
				})
			},
			confirmToClose() {
				if (this.typeIndex == 0) {
					this.startOrNot = 0
				} else {
					this.typeIndex = 1
				}
				this.dialogTableVisible = false
			},
			switchType(i) {
				if (this.startOrNot == 1) {
					this.dialogTableVisible = true
				} else {
					if (i == 1) {
						this.resultCategory()
					}
					this.resultId = ''
					this.typeIndex = i
				}
			},
			diagnosticDetails(item) {
				this.resultId = item.resultId
				this.esultDetails()
			},
			//诊断结果详情
			esultDetails() {
				diagnosticResultDetails({
					resultId: this.resultId
				}).then(res => {
					if (res.code == 200) {
						this.detailsOfCases = res.data
						this.recordDiagnoseData = this.processDiagnoseData(res.data.diagnose);
					}
				})
			},
			//结果列表
			resultCategory() {
				resultList({
					type: 1
				}).then(res => {
					if (res.code == 200) {
						this.listOfCases = res.rows
					}
				})
			},
			//选择
			select(index, item) {
				if (this.topicContent.secondType == 0) { //单选
					if (this.selectedArr[0] !== index) {
						this.selectedArr = [];
						this.selectedArr.push(index);
					} else {
						this.selectedArr = [];
					}
				} else { //可多选
					let searchIndex = this.selectedArr.indexOf(index);
					if (searchIndex === -1) {
						this.selectedArr.push(index);
					} else {
						this.selectedArr.splice(searchIndex, 1);
					}
				}

			},
			// 上一题
			previousMention() {
				if (this.whatQuestionIsIt > 0) {
					this.whatQuestionIsIt--
					this.subject()
				}
			},
			// 下一题
			nextQuestion() {
				// this.answerIds = []
				if ((this.whatQuestionIsIt + 1) < this.total) {
					console.log(this.selectedArr.length)
					if (this.selectedArr.length == 0) {
						this.$message({
							message: '请选择答案',
							type: 'warning'
						});
					} else {
						this.selectedArr.forEach((el) => {
							this.answerIds.push(this.list[el].answerId);
						});
						submitResults({
							answerIds: this.answerIds,
							questionId: this.topicContent.questionId
						}).then(res => {
							this.selectedArr = []
							this.answerIds = []
							// console.log(this.answerIds)
							this.whatQuestionIsIt++
							this.subject()
							// console.log(res, '2222222');
						})
					}

				} else {
					if (this.selectedArr.length == 0) {
						this.$message({
							message: '请选择答案',
							type: 'warning'
						});
					} else {
						this.$confirm('是否确定提交此次测评？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							this.selectedArr.forEach((el) => {
								this.answerIds.push(this.list[el].answerId);
							});
							submitResults({
								answerIds: this.answerIds,
								questionId: this.topicContent.questionId
							}).then(res => {
								this.selectedArr = []
								this.answerIds = []
								// console.log(this.answerIds)
								this.subject()
								// console.log(res, '2222222');
							})
							// if (this.classid == 0) {
							const loading = this.$loading({
								lock: true,
								text: '生成报告中',
								spinner: 'el-icon-loading',
								background: 'rgba(0, 0, 0, 0.7)'
							});
							endTheQuiz({
								address: this.local.province + this.local.city + this.local.district,
								weather: this.local.weather,
								wind: this.local.wind,
								temperature: this.local.temperature,
								humidity: this.local.humidity,
								classifyId: this.classid,
							}).then(res => {
								if (res.code == 200) {
									this.evaluationResults = res.data
									this.currentDiagnoseData = this.processDiagnoseData(res.data.diagnose);
									this.startOrNot = -1
									this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
										loading.close();
									});


								} else {
									this.$message({
										message: res.msg,
										type: 'warning'
									});
								}
								console.log(res)
							})
							// } else {
							// 	endTheQuiz({
							// 		address: this.local.province + this.local.city + this.local.district,
							// 		weather: this.local.weather,
							// 		wind: this.local.wind,
							// 		temperature: this.local.temperature,
							// 		humidity: this.local.humidity,
							// 		classifyId: this.classid,
							// 	}).then(res => {
							// 		if (res.code == 200) {
							// 			this.healthContent = res.data
							// 			this.suspectedDiagnosis = true
							// 		} else {
							// 			this.$message({
							// 				message: res.msg,
							// 				type: 'warning'
							// 			});
							// 		}
							// 		console.log(res)
							// 	})
							// }

						}).catch(() => {
							this.$message({
								type: 'info',
								message: '已取消'
							});
						});
					}
				}
			},
			answerList(i) {
				// if (this.problem.total == 0) {
				// 	this.$message({
				// 		message: '暂无题目',
				// 		type: 'warning'
				// 	});
				// 	return
				// }
				answer({
					type: 1,
					// classifyId: i,
				}).then(res => {
					this.startOrNot = 1
					this.classid = i
					this.subject()
					console.log(res, '2222222');
				})
			},
			subject() {
				this.selectedArr = []
				newProblem({
					type: 1,
					index: this.whatQuestionIsIt,
					classifyId: this.classid
				}).then(res => {
					if (res.code == 200) {
						this.total = res.data.total
						this.list = res.data.question.answerList
						this.topicContent = res.data.question
						if (res.data.myAnswer != null) {
							res.data.myAnswer.forEach((s, r) => {
								console.log(res.data.myAnswer)
								for (var i = 0; i < this.list.length; i++) {
									// console.log(s, r, this.list[i].answerId)
									if (s == this.list[i].answerId) {
										this.selectedArr.push(i)
										console.log(this.selectedArr)
									}
								}
							})
						}
					}

					console.log(res, '2222222');
				})
			},
			jumpTo() {
				this.$router.push({
					path: '/evaluationDetails',
					query: {
						id: '123'
					}
				}).catch(() => {})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.organized {

		::v-deep .el-dialog {
			background: none !important;
			box-shadow: none;
			width: 463px;
			height: 378px;
		}


	}

	.closeButton {
		width: 463px;
		margin: 0 auto;
		text-align: center;
		margin-top: 30px;

		img {
			width: 30px;
			height: 30px;
			margin: 0 auto;
			text-align: center;
		}
	}

	.isItClosed {
		width: 463px;
		height: 378px;
		position: relative;

		img {
			width: 463px;
			height: 378px;
		}

		.overallContent {
			position: absolute;
			left: 33px;
			right: 33px;
			top: 209px;

			.contentser {
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				font-size: 22px;
				color: #5E524D;
				text-align: center;
			}

			.buttonOperation {
				width: 170px;
				height: 44px;
				background: #F2E1C5;
				border-radius: 26px 26px 26px 26px;
				font-family: PingFang SC, PingFang SC;
				font-weight: bold;
				font-size: 20px;
				color: #92643D;
				text-align: center;
				line-height: 44px;
				margin: 0 auto;
				margin-top: 42px;
			}
		}
	}

	::v-deep .el-dialog {
		width: 557px;
		height: 340px;
		background: #FFFFFF;
		border-radius: 10px 10px 10px 10px;
	}

	.endEvaluation {
		cursor: default;

		.title {
			font-family: PingFang SC, PingFang SC;
			font-weight: bold;
			font-size: 18px;
			color: #333333;
			text-align: center;
		}

		.contentDissemination {
			width: 246px;
			height: 48px;
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 16px;
			color: #333333;
			text-align: center;
			margin: 44px auto;
		}

		.operationButton {
			display: flex;
			align-items: center;
			justify-content: space-around;
			padding-top: 40px;

			.determine {
				width: 151px;
				height: 36px;
				background: #FFFFFF;
				border-radius: 20px 20px 20px 20px;
				border: 1px solid #92643D;
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				font-size: 15px;
				color: #92643D;
				text-align: center;
				line-height: 36px;
			}

			.cancel {
				width: 151px;
				height: 36px;
				background: #E0C79F;
				border-radius: 20px 20px 20px 20px;
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				font-size: 15px;
				color: #92643D;
				text-align: center;
				line-height: 36px;
			}
		}
	}

	.classification {
		cursor: default;

		.singleType {
			width: 202px;
			height: 50px;
			background: #F1F1F1;
			border-radius: 0px 0px 0px 0px;
			line-height: 50px;
			padding-left: 18px;
			font-family: Microsoft YaHei, Microsoft YaHei;
			font-weight: 400;
			font-size: 15px;
			color: #333333;
		}

		.active {
			background: #D89A3A;
			color: #fff;
		}
	}

	.diagnosis {
		margin-left: 20px;
		padding-bottom: 132px;
		// position: relative;
		cursor: default;

		.crumbs {
			font-family: Microsoft YaHei, Microsoft YaHei;
			font-weight: 400;
			font-size: 14px;
			color: #666666;
			margin-bottom: 20px;
		}

		.stagQuestions {
			width: 959px;
			height: 630px;
			background: #FFFFFF;
			border-radius: 0px 0px 0px 0px;
			margin: 0 auto;
			text-align: center;

			.northwestIsBeingRectified {
				display: flex;
				align-items: center;
				justify-content: space-evenly;
				margin-top: 50px;

				.evaation {
					width: 204px;
					height: 40px;
					background: #FFF4E3;
					border-radius: 30px 30px 30px 30px;
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-weight: 500;
					font-size: 8rpx;
					color: #DF632B;
					text-align: center;
					line-height: 40px;
				}
			}

			img {
				margin-top: 85px;
				width: 266px;
				height: 371px;
			}

			.evaluation {
				width: 204px;
				height: 40px;
				background: #DF632B;
				border-radius: 30px 30px 30px 30px;
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-weight: 500;
				font-size: 16px;
				color: #FFFFFF;
				text-align: center;
				line-height: 40px;
			}

			.evtionTips {
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-weight: 400;
				font-size: 12px;
				color: #937154;
				margin-top: 20px;
			}
		}
	}

	.evation {
		width: 959px;
		padding: 23px 0;
		background: #FFFFFF;


		.assessmentProgress {
			display: flex;
			align-items: center;
			padding: 0 80px;

			.speedOfProgress {
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				font-size: 14px;
				color: #5F3A1B;
			}

			.numberOfAnswers {
				font-family: PingFang SC, PingFang SC;
				font-weight: bold;
				font-size: 18px;
				color: #5F3A1B;

				span {
					color: #DF632B;
				}
			}
		}

		.progressBar {
			padding: 0 80px;
			margin-top: 14px;

		}

		.topicType {
			font-family: PingFang SC, PingFang SC;
			font-weight: bold;
			font-size: 16px;
			color: #333333;
			padding: 0 80px;
			margin-top: 40px;
		}

		.titles {
			font-family: PingFang SC, PingFang SC;
			font-weight: bold;
			font-size: 16px;
			color: #333333;
			padding: 0 80px;
			margin-top: 14px;
		}

		.topicSelection {
			margin: 0 auto;
			text-align: center;
			margin-top: 30px;

			.singleOption {
				margin: 0 auto;
				margin-bottom: 14px;
				width: 489px;
				// height: 46px;
				background: #F4F4F4;
				border-radius: 4px 4px 4px 4px;
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				font-size: 16px;
				color: #333333;
				text-align: center;
				line-height: 46px;
			}

			.span-active {
				background: #FDF1EB;
				color: #DF632B;
			}
		}

		.selectType {
			display: flex;
			align-items: center;
			justify-content: space-evenly;
			padding-bottom: 20px;
			margin-top: 50px;

			.previousQuestion {
				width: 164px;
				height: 44px;
				background: #E0C79F;
				border-radius: 30px 30px 30px 30px;
				font-family: PingFang SC, PingFang SC;
				font-weight: bold;
				font-size: 16px;
				color: #92643D;
				text-align: center;
				line-height: 44px;
			}

			.nextQuestion {
				width: 164px;
				height: 44px;
				background: #DF632B;
				border-radius: 30px 30px 30px 30px;
				font-family: PingFang SC, PingFang SC;
				font-weight: bold;
				font-size: 16px;
				color: #FFFFFF;
				text-align: center;
				line-height: 44px;
			}
		}
	}

	.score {

		background: #fff;
		padding: 15px 30px;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.scoreser {
			display: flex;
			align-items: center;

			div {
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				font-size: 16px;
				color: #333333;
				margin-left: 10px;

				span {
					font-family: PingFang SC, PingFang SC;
					font-weight: bold;
					font-size: 16px;
					color: #FF7200;
				}
			}

			img {
				width: 20px;
				height: 20px;
			}
		}

		.scoringTime {
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 12px;
			color: #666666;
		}
	}

	.ratingBackground {
		width: 680px;
		height: 140px;
		margin-left: 50px;
		margin-top: 20px;
		position: relative;

		.backgroundImage {
			width: 680px;
			height: 140px;

			img {
				width: 680px;
				height: 140px;
			}
		}

		.ratingPerson {
			position: absolute;
			top: 26px;
			left: 20px;
			display: flex;
			align-items: center;

			.headPortrait {
				width: 44px;
				height: 44px;
				border-radius: 100%;
			}

			.nickname {
				margin-left: 10px;

				.rPerson {
					display: flex;
					align-items: center;
					font-family: PingFang SC, PingFang SC;
					font-weight: bold;
					font-size: 15px;
					color: #333333;

					img {
						width: 16px;
						height: 16px;
						margin-left: 10px;
					}
				}

				.age {
					font-family: PingFang SC, PingFang SC;
					font-weight: 500;
					font-size: 12px;
					color: #666666;
				}
			}
		}

		.answeringScore {
			position: absolute;
			bottom: 30px;
			left: 20px;
			display: flex;
			align-items: center;

			.fraction {
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				font-size: 14px;
				color: #333333;

				span {
					font-family: PingFang SC, PingFang SC;
					font-weight: bold;
					font-size: 20px;
					color: #DF632B;
				}
			}

			.testTime {
				margin-left: 30px;
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				font-size: 10px;
				color: #666666;
			}
		}

	}

	.linkDeduction {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 0 auto;
		position: relative;
		text-align: center;

		.leftLink {
			width: 8px;
			height: 35px;
			position: absolute;
			left: 143px;
		}

		.rightLink {
			width: 8px;
			height: 35px;
			position: absolute;
			left: 675px;
		}
	}

	.resultContent {
		margin-left: 50px;
		margin-top: 5px;
		padding: 30px;
		width: 620px;
		// height: 516px;
		background: linear-gradient(180deg, #FFFFFF 52%, #F7F1E3 100%);
		border-radius: 10px 10px 10px 10px;

		.titlese {
			font-family: Source Han Serif CN, Source Han Serif CN;
			font-weight: bold;
			font-size: 18px;
			color: #D2470B;
			text-align: center;
			padding-bottom: 16px;
		}

		.diagnosticContent {
			padding-bottom: 30px;
			font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
			font-weight: 400;
			font-size: 14px;
			color: #666666;
			white-space: pre-wrap;
		}

		.downloadFile {
			width: 325px;
			height: 44px;
			background: #DF632B;
			border-radius: 30px 30px 30px 30px;
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 16px;
			color: #FFFFFF;
			margin: 0 auto;
			line-height: 44px;
			text-align: center;
		}
	}
</style>